import React from 'react';
import { Box, Typography } from '@mui/material';

const DAI: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        DAI Testing Area
      </Typography>
      <Typography>
        This is where you can test the DAI model.
      </Typography>
    </Box>
  );
};

export default DAI;
